import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
// import logo from 'assets/img/illustrations/falcon.png';
import logo from 'assets/img/illustrations/falcon.png';
import { useAppContext } from 'providers/AppProvider';

const Logo = ({ at = 'auth', width = 58, className, textClass, ...rest }) => {

  const {
    config: {
      userAuth
    },
  } = useAppContext();

  // const linkPath = userAuth === 'SA' ? '/dashboard/crm' : '/';
  const linkPath = userAuth === 'SA' ? '/safedb/SA/adminSites' : '/';


  return (
    <Link
      to={linkPath}
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-4 mb-4': at === 'auth'
          },
          className
        )}
      >
        {/* <img className="me-2" src={logo} alt="Logo" width={width} /> */}
        <img className="me-2" src='/img/INISAFE_SAFEDB.png' alt="Logo" width='130px' />
        {/* <span className={classNames('font-sans-serif', textClass)}>SafeDB</span> */}
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

export default Logo;
